module.exports = __webpack_public_path__ + "static/media/YF19_1.91d6e1b9.jpg";